
import { fromInt32, op_Multiply, toInt64_unchecked } from "../fable_modules/fable-library-js.5.0.0-rc.2/BigInt.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export const maxRequestBodySizeInMegabytes = 75;

export const maxRequestBodySizeInBytes = toInt64_unchecked(op_Multiply(toInt64_unchecked(op_Multiply(toInt64_unchecked(fromInt32(maxRequestBodySizeInMegabytes)), 1024n)), 1024n));

export class FileUploaded extends Record {
    constructor(ImageUrl) {
        super();
        this.ImageUrl = ImageUrl;
    }
}

export function FileUploaded_$reflection() {
    return record_type("Shared.File.FileUploaded", [], FileUploaded, () => [["ImageUrl", string_type]]);
}

export class FileUploadResponse extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FileTooLarge", "Successful", "Failed"];
    }
}

export function FileUploadResponse_$reflection() {
    return union_type("Shared.File.FileUploadResponse", [], FileUploadResponse, () => [[], [["Item", FileUploaded_$reflection()]], []]);
}

